import { render, staticRenderFns } from "./MediaFileOverlay.vue?vue&type=template&id=537b970d&scoped=true&"
import script from "./MediaFileOverlay.vue?vue&type=script&lang=ts&"
export * from "./MediaFileOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./MediaFileOverlay.vue?vue&type=style&index=0&id=537b970d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537b970d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VBtn,VIcon,VOverlay})
